// extracted by mini-css-extract-plugin
module.exports = {"mainSingleContainerWrapper":"CollaboratorsShow_mainSingleContainerWrapper__2DImG"};